/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { useEffect, useState } from "react";
import style from "./home.module.css";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import { Carousel } from "react-bootstrap";
import "react-multi-carousel/lib/styles.css";
import { useDashBoardData } from "../../context/dashboardDataContext/DashboardDataContext";
import Loader from "../../components/loader/Loader";
import DataNotFound from "../../components/dataNotFound/DataNotFound";
import { PiArrowCircleRight } from "react-icons/pi";
import ImageVideoGallery from "../../components/imageGallery/ImageVideoGallery";
import AOS from "aos";
import "aos/dist/aos.css";
import InfoPopup from "../../components/InfoPopup/InfoPopup";

const Home = () => {
  const { dashboardData, bannerData, isLoading, mobileBannerData } =
    useDashBoardData();

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    AOS.init({
      offset: 200,
      once: false,
    });
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className={`container-fluid ${style.home_container_fluid}`}>
          {/* banner row */}
          <div className="row" id={`${style.banner_row_id}`}>
            <div
              className={`col-lg-12 ps-0 pe-0 ${style.desktop_view_banner_row}`}
            >
              <div className={`${style.item}`}>
                <Carousel interval={2000} pauseonhover="true">
                  {bannerData.map((item, index) => {
                    return (
                      <Carousel.Item key={index}>
                        <img
                          src={item.banner}
                          className={`img-fluid w-100 ${style.home_banner_img}`}
                          alt="banner"
                          loading="lazy"
                        />
                      </Carousel.Item>
                    );
                  })}
                </Carousel>
              </div>
            </div>
            {/* mobile view banner */}
            <div
              className={`col-lg-12 ps-0 pe-0 ${style.mobile_view_banner_row}`}
            >
              <div className={`${style.item}`}>
                <Carousel interval={2000} pauseonhover="true">
                  {mobileBannerData.map((item, index) => {
                    return (
                      <Carousel.Item key={index}>
                        <img
                          src={item.banner}
                          className={`img-fluid w-100`}
                          alt="banner"
                          loading="lazy"
                        />
                      </Carousel.Item>
                    );
                  })}
                </Carousel>
              </div>
            </div>
            <div className="col-lg-12 ps-0 pe-0">
              <div className={`${style.marquee_sec}`}>
                <marquee
                  className={`${style.home_marquee}`}
                  behavior="smooth"
                  direction="left"
                >
                  <ul className={`${style.home_marquee_ul}`}>
                    <li className={`${style.marquee_list}`}>
                      संविधान आणि कायदा
                    </li>
                    <li className={`${style.marquee_list}`}>केंद्र सरकार</li>
                    <li className={`${style.marquee_list}`}>संसद</li>
                    <li className={`${style.marquee_list}`}>
                      निवडणुका आणि राजकीय पक्ष
                    </li>
                    <li className={`${style.marquee_list}`}>न्यायव्यवस्ता</li>
                    <li className={`${style.marquee_list}`}>
                      प्रशासकीय आणि विभाग
                    </li>
                    <li className={`${style.marquee_list}`}>पंचायत सदस्य</li>
                    <li className={`${style.marquee_list}`}>सरपंच</li>
                    <li className={`${style.marquee_list}`}>सभा</li>
                    <li className={`${style.marquee_list}`}>निवडणूक</li>
                    <li className={`${style.marquee_list}`}>
                      संविधान आणि कायदा
                    </li>
                    <li className={`${style.marquee_list}`}>केंद्र सरकार</li>
                    <li className={`${style.marquee_list}`}>संसद</li>
                    <li className={`${style.marquee_list}`}>
                      निवडणुका आणि राजकीय पक्ष
                    </li>
                    <li className={`${style.marquee_list}`}>न्यायव्यवस्ता</li>
                  </ul>
                </marquee>
                <div className={`${style.marquee_first_line}`}></div>
                <div className={`${style.marquee_second_line}`}></div>
              </div>
            </div>
          </div>

          {/* village summary row */}
          <div
            className={`${style.village_summary_row}`}
            id={`${style.village_row_id}`}
          >
            <header className={`${style.members_top_common_title_sec}`}>
              {/* <span className={`${style.members_c_span_title}`}>
                Village summary at glance
              </span> */}
              <div className="my-3">
                <h1>ग्रामसंपर्क — माहिती व सेवा</h1>
                <h5 className={`${style.members_c_heading_title}`}>
                  गावाशी जोडणारा दुवा
                </h5>
              </div>
            </header>
            <div className={style.village_summary_main}>
              {dashboardData?.gram_panchayat_overview?.length > 0 ? (
                dashboardData?.gram_panchayat_overview?.map((ele, index) => {
                  return (
                    <div
                      // data-aos="fade-left"
                      // data-aos-duration="1500"
                      className={`  ${style.village_summary_col}`}
                      style={{
                        backgroundColor:
                          index === 0
                            ? "rgba(228, 244, 241, 0.8)"
                            : index === 1
                            ? "rgba(255, 87, 34, 0.11)"
                            : index === 2
                            ? "rgba(239, 233, 251, 0.81)"
                            : "rgba(246, 241, 219, 0.8)",
                      }}
                      key={ele.id}
                    >
                      <div
                        className={` ${style.common_village_summary_column}`}
                       
                      >
                        <div className={`${style.village_s_left_sec}`}>
                          <img
                            src={ele.image}
                            alt="charts"
                            className="img-fluid"
                            loading="lazy"
                          />
                        </div>
                        <div className={`${style.village_s_right_sec}`}>
                          <p className={`${style.v_s_r_s_title}`}>
                            {ele.title}
                          </p>
                          <p className={`${style.v_s_r_s_second_title}`}>
                            {ele.count}
                          </p>
                          {/* <Link
                          to=""
                          className={`${style.v_s_r_s_read_more_btn}`}
                        >
                          More
                        </Link>
                        <Link
                          to=""
                          className={`${style.v_s_r_s_read_more_mobile_btn}`}
                        >
                          <GoArrowRight />
                        </Link> */}
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="col-lg-12">
                  <DataNotFound />
                </div>
              )}
            </div>
          </div>

          {/* gram members row */}
          <div
            className={`row ${style.members_row}`}
            id={`${style.members_row_id}`}
          >
            <header className={`${style.members_top_common_title_sec}`}>
              <span className={`${style.members_c_span_title}`}>Member’s</span>
              <h5 className={`${style.members_c_heading_title}`}>
                ग्रामपंचायत सदस्य <span>2023-24</span>
              </h5>
            </header>
            <div className={style.main_members_column}>
              {dashboardData?.members?.length > 0 ? (
                dashboardData?.members?.map((ele) => {
                  return (
                    <div
                      data-aos="fade-right"
                      data-aos-duration="1500"
                      className={`${style.members_column}`}
                      key={ele.id}
                    >
                      <div className={`${style.members_col_common}`}>
                        <div className={`${style.members_col_left_sec}`}>
                          <div
                            className={`${style.background_img_set}`}
                            style={{
                              backgroundImage: `url('${ele.image}')`,
                              backgroundSize: "cover",
                              backgroundPosition: "inherit",
                              backgroundRepeat: "no-repeat",
                            }}
                          />
                          <div className={`${style.m_c_l_s_bottom_sec}`}>
                            <p className={`${style.m_c_l_s_bottom_sec_para}`}>
                              {ele.title}
                            </p>
                            <span
                              className={`${style.m_c_l_s_bottom_sec_span}`}
                            >
                              {ele.role_name}
                            </span>
                          </div>
                        </div>
                        {/* <div className={`${style.members_col_right_sec}`}>
                        <p className={`${style.m_c_r_sec_para}`}>
                          {" "}
                          <p
                            dangerouslySetInnerHTML={{
                              __html: ele.description,
                            }}
                          />
                        </p>
                        <Link
                          to="/gpt_members"
                          className={`${style.member_read_more_btn}`}
                        >
                          Read More
                        </Link>
                        <Link
                          to="/gpt_members"
                          className={`${style.member_read_more_btn_mobile_show}`}
                        >
                          <PiArrowCircleRight />
                        </Link>
                      </div> */}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="col-lg-12">
                  <DataNotFound />
                </div>
              )}
            </div>
            <div className="d-flex justify-content-center my-4">
              <Link
                to="gpt_members"
                className="btn text-primary fw-bold text-decoration-underline"
              >
                सर्व ग्रामपंचायत सदस्य पहा
              </Link>
            </div>
            <div className={`${style.members_bottom_line}`}></div>
          </div>

          {/* Public facilities row */}
          <div
            className={`row ${style.public_facilities_row}`}
            id={`${style.facilities_row_id}`}
          >
            <header className={` mb-2 ${style.members_top_common_title_sec}`}>
              <span className={`${style.members_c_span_title} text-white`}>
                Public facilities
              </span>
              <h5 className={` text-white  ${style.members_c_heading_title}`}>
                सार्वजनिक सुविधा
              </h5>
            </header>
            {dashboardData?.public_facility?.length > 0 ? (
              dashboardData?.public_facility?.map((ele) => {
                return (
                  <div
                    data-aos="fade-up"
                    data-aos-anchor-placement="bottom-bottom"
                    data-aos-duration="1500"
                    className={`col-lg-2 mb-2 ${style.public_f_col}`}
                    key={ele.id}
                     onClick={() => setIsOpen(true)}
                  >
                    <div className={`${style.public_facilities_sec}`}>
                      <img
                        src={ele.image}
                        alt="facilities"
                        loading="lazy"
                        className="img-fluid"
                      />
                      <p className={`${style.public_facilities_sec_title_one}`}>
                        {ele.title}
                      </p>
                      <h2
                        className={`${style.public_facilities_sec_title_second}`}
                      >
                        {ele.count}
                      </h2>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="col-lg-12">
                <DataNotFound />
              </div>
            )}
          </div>

          {/* photos and video row */}
          <div
            className={`row ${style.photos_row}`}
            id={`${style.photos_video_row_id}`}
          >
            <header className={`${style.members_top_common_title_sec}`}>
              <span className={`${style.members_c_span_title}`}>
                photos/ video
              </span>
              <h5
                className={`${style.members_c_heading_title} ${style.members_c_heading__white_title}`}
              >
                फोटो/व्हिडीओ
              </h5>
            </header>
            <ImageVideoGallery />
          </div>

          {/* important places row */}
          <div
            className={`row ${style.village_summary_row}`}
            id={`${style.imp_place_row_id}`}
          >
            <header className={`${style.members_top_common_title_sec}`}>
              <span className={`${style.members_c_span_title}`}>
                important place
              </span>
              <h5 className={`${style.members_c_heading_title}`}>
                प्रमुख स्थळे
              </h5>
            </header>
            {dashboardData?.important_places?.length > 0 ? (
              dashboardData?.important_places?.map((ele) => {
                return (
                  <div
                    data-aos="fade-up"
                    data-aos-duration="1500"
                    key={ele.id}
                    className={`col-lg-6 col-md-6 mb-5 ${style.place_col_left}`}
                  >
                    <div className={`${style.important_place_left_sec}`}>
                      <div className={`${style.i_p_l_s_first}`}>
                        <img
                          src={require("../../assets/images/home/temple_hindu.png")}
                          alt="place"
                          className="img-fluid"
                          loading="lazy"
                        />
                        <span className={`${style.i_p_l_s_first_span}`}>
                          {ele.title}
                        </span>
                      </div>
                      <p
                        className={`${style.i_p_l_s_para}`}
                        dangerouslySetInnerHTML={{
                          __html: ele.description,
                        }}
                      />
                      <div className={`${style.imp_place_read_more_btn}`}>
                        <Link to="/imp-places">Read More</Link>
                      </div>
                    </div>
                    <div className={`${style.important_place_right_sec}`}>
                      <div className={`${style.imp_place_r_s_first_d}`}>
                        <div
                          className={`${style.background_img_set_place}`}
                          style={{
                            backgroundImage: `url('${ele.image}')`,
                            backgroundSize: "cover",
                            backgroundPosition: "inherit",
                            backgroundRepeat: "no-repeat",
                          }}
                        />
                      </div>
                      {/* <div className={`${style.imp_place_r_s_second_d}`}>
                        <iframe
                          src={ele.map_url}
                          allowFullScreen=""
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                          className={`${style.places_all_map}`}
                          title="place"
                        ></iframe>
                      </div> */}
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="col-lg-12">
                <DataNotFound />
              </div>
            )}
            <hr className={`${style.place_hr}`} />
          </div>

          {/* latest news row */}
          <div
            className={`row ${style.latest_news_row}`}
            id={`${style.latest_news_row_id}`}
          >
            <header className={`${style.members_top_common_title_sec} mt-4`}>
              <span className={`${style.members_c_span_title}`}>
                LATEST NEWS
              </span>
              <h5 className={`${style.members_c_heading_title}`}>
                प्रशासकीय कार्ये
              </h5>
            </header>
            {dashboardData?.latest_news?.length > 0 ? (
              dashboardData?.latest_news?.map((ele) => {
                return (
                  <div
                    key={ele.id}
                    // data-aos="fade-right"
                    // data-aos-duration="2000"
                    className={`col-lg-4 col-md-6 mb-3 ${style.latest_news_first_col}`}
                  >
                    <div className={`${style.latest_news_first_sec}`}>
                      <p className={`${style.latest_news_first_s_title}`}>
                        {ele.title}
                      </p>
                      <img
                        src={ele.image}
                        alt="news"
                        loading="lazy"
                        className="img-fluid"
                      />
                      <p
                        className={`${style.latest_news_first_s_bottom_para}`}
                        dangerouslySetInnerHTML={{
                          __html: ele.description,
                        }}
                      />
                      {/* <div className={`${style.latest_new_read_more_btn}`}>
                        <Link to="/social-works">Read More</Link>
                      </div>
                      <div
                        className={`${style.latest_new_read_more_mobile_btn}`}
                      >
                        <Link to="/social-works">
                          <SlArrowRightCircle />
                        </Link>
                      </div> */}
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="col-lg-8">
                <DataNotFound />
              </div>
            )}
            <div
              // data-aos="fade-left"
              // data-aos-duration="2000"
              className={`col-lg-4 col-md-12 ${style.latest_news_second_col}`}
            >
              <div className={`${style.latest_new_third_sec}`}>
                <p className={`${style.latest_new_third_sec_title}`}>
                  what is new
                </p>
                <ul className={`${style.latest_new_third_sec_ul_list}`}>
                  {dashboardData?.what_new?.slice(0, 6).map((ele) => {
                    return (
                      <li key={ele.id} className={`${style.l_n_t_s_list}`}>
                        <Link
                          to={ele.url}
                          target="_blank"
                          dangerouslySetInnerHTML={{
                            __html: ele.title,
                          }}
                          title={ele.title}
                        />
                      </li>
                    );
                  })}
                </ul>
                <div className={`${style.latest_view_all_btn}`}>
                  <Link data-bs-toggle="modal" data-bs-target="#whatIsNewModal">
                    View All
                  </Link>
                  <Link data-bs-toggle="modal" data-bs-target="#whatIsNewModal">
                    <BsArrowRight />
                  </Link>
                </div>

                {/* what is new pop up */}
                <div
                  className="modal fade"
                  id="whatIsNewModal"
                  tabIndex="-1"
                  aria-labelledby="whatIsNewLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h1
                          className="modal-title common-modal-title"
                          id="whatIsNewLabel"
                        >
                          WHAT IS NEW
                        </h1>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        <ul className={`${style.latest_new_third_sec_ul_list}`}>
                          {dashboardData?.what_new?.map((ele) => {
                            return (
                              <li
                                key={ele.id}
                                className={`${style.l_n_t_s_list}`}
                              >
                                <Link
                                  to={ele.url}
                                  target="_blank"
                                  dangerouslySetInnerHTML={{
                                    __html: ele.title,
                                  }}
                                  s
                                  title={ele.title}
                                />
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={`${style.latest_new_select_date_sec}`}>
              <span>गुरुवार,२८ डिसेंबर २०२३</span>
            </div>
          </div>
          {/* Schemes row */}
          <div
            className={`row ${style.schemes_row}`}
            id={`${style.schemes_row_id}`}
          >
            <header className={`${style.members_top_common_title_sec}`}>
              <span className={`${style.members_c_span_title}`}>Schemes</span>
              <h5 className={` text-white  ${style.members_c_heading_title}`}>
                ग्रामपंचायत योजना
              </h5>
            </header>
            <hr className={`${style.scheme_hr}`} />
            {dashboardData?.schemes?.length > 0 ? (
              dashboardData?.schemes?.map((ele) => {
                return (
                  <div
                    key={ele.id}
                    data-aos="flip-down"
                    data-aos-duration="1500"
                    className={`col-lg-3 col-md-6 ${style.scheme_col}`}
                  >
                    <div className={`${style.scheme_card}`}>
                      <div className={`${style.card_img}`}>
                        <img
                          src={ele.image}
                          alt="schemes"
                          loading="lazy"
                          className="img-fluid w-100"
                        />
                      </div>
                      <div className={`${style.scheme_card_body}`}>
                        <p
                          title={ele.title}
                          className={`${style.scheme_card_title}`}
                        >
                          {ele.title}
                        </p>
                        <p
                          className={`${style.scheme_card_para}`}
                          dangerouslySetInnerHTML={{
                            __html: ele.description,
                          }}
                        />
                        <div className={`${style.scheme_card_footer}`}>
                          <Link to="/schemes">More</Link>
                          <Link to="/schemes">
                            <BsArrowRight />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="col-lg-12">
                <DataNotFound />
              </div>
            )}
          </div>
          {/* client logos */}
          <div
            className={`row ${style.client_logo_row}`}
            id={`${style.client_row_id}`}
          >
            <div
              data-aos="zoom-in-left"
              data-aos-duration="1500"
              className="col-lg-12 ps-0 pe-0"
            >
              <ul className={`${style.client_logo_ul_list}`}>
                {dashboardData?.co_partner?.length > 0 ? (
                  dashboardData?.co_partner?.map((ele) => {
                    return (
                      <li key={ele.id} className={`${style.client_logo_list}`}>
                        <img
                          src={ele.image}
                          alt="client"
                          className="img-fluid"
                          loading="lazy"
                        />
                      </li>
                    );
                  })
                ) : (
                  <DataNotFound />
                )}
              </ul>
            </div>
          </div>
          <InfoPopup isOpen={isOpen} setIsOpen={setIsOpen}/>
        </div>
      )}
    </>
  );
};

export default Home;
